var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"outlined":""},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var item = ref.item;
return [_c('b-btn',{staticClass:"pl-0",attrs:{"variant":"link","to":{
        name: 'project-task-default-edit',
        params: {
          id: item.id
        }
      }}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])]}},{key:"value",fn:function(ref){
      var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(item.value)+"日 ")])]}},{key:"actions",fn:function(ref){
      var item = ref.item;
return [(!item.code)?_c('b-btn',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.deleteItem(item.id)}}},[_vm._v("\n      削除\n    ")]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }